import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { AutoComplete, Popover, /* Button, */ Spin, /* message, */ Tooltip } from 'antd';
import { store } from 'Store/store.index';
import intl from 'react-intl-universal';
import './SharedUserList.scss';
// import addIcon from 'assets/Collaboration/plus.svg'
import { isPhantomOnline, getQueryVariable } from '@/utils/utils';
import moment from 'moment';
import { UTCTimeToLocale } from 'Utils/date';
// import { ADD_MORE_PEOPLE_SUCCESS,  ADD_MORE_PEOPLE_FAILED } from 'Components/viewer/ui/constants/user.more.constants';
import {
  VIEW_PARTICIPANTS,
  INVITE_PEOPLE,
  /* ADD_MORE_PEOPLE, */ VIEW_PARTICIPANTS_BY_YOU,
  VIEW_PARTICIPANTS_BY_OTHERS,
} from '../../viewer/ui/constants/event.constants.share';
const { Option } = AutoComplete;

/*
 params
 @peopleList: Array // This is a list of members who share files
 @reviewSessionID: String // Request user data necessary parameters
 @cDocID: String // Document ID
 @fileLink: Sreing // Online document address
 @shareState: Number(0: share | 1: not) // Whether or not to share
 @type: String (yours|others) // Share whether the file is yours
 */
class SharedUserList extends Component {
  constructor(props) {
    super(props);
    this.userListRef = null;
    this.SharedUserListRef = React.createRef();
    this.portraitListRef = React.createRef();
    this.rightArrowRef = React.createRef();
    this.totalUserRef = React.createRef();
    this.state = {
      userBgColorList: ['#48D2D4', '#BA91FF', '#FFCA60', '#75D060', '#FF8294'],
      notPhantomOnline: false,
      isolateComponent: false,
      visible: false,
      isSuccess: false,
      successLength: 0,
      isLoading: false,
      isAddUser: false,
      userList: [],
      addOption: [],
      selectData: [],
      userListData: [],
      detailsUserList: [],
      email: '',
      userListLoading: true,
      propsData: {
        peopleList: this.props.peopleList || [],
      },
      outerInviteParticipant: this.props.outerInviteParticipant || undefined,
    };
  }
  componentDidMount() {
    if (!isPhantomOnline()) {
      this.setState({
        notPhantomOnline: true,
      });
    }
    if (!this.props.parentCom) {
      this.setState({
        isolateComponent: true,
      });
    }
    if (!isPhantomOnline() && !this.props.parentCom) {
      setTimeout(() => {
        this.getShareReview();
      }, 500);
    }

    this.calcPortraitList();

    window.addEventListener('resize', this.calcPortraitList);
  }
  componentDidUpdate(prevProps) {
    const { notPhantomOnline } = this.state;

    if (!notPhantomOnline) {
      if (this.props.peopleList.length !== prevProps.peopleList.length) {
        this.calcPortraitList();
      }
    } else {
      this.postWinSizeForPhantom();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.calcPortraitList);
  }
  postWinSizeForPhantom = () => {
    const { notPhantomOnline, isolateComponent } = this.state;

    if (notPhantomOnline && isolateComponent && this.userListRef) {
      const targetNode = this.userListRef;

      if (targetNode) {
        console.log(targetNode.clientWidth, targetNode.clientHeight);
        store.collaborationStore.postWinSizeMsg({ name: 'SharedUserList', width: targetNode.clientWidth, height: targetNode.clientHeight });
      }
    }
  };
  calcPortraitList = () => {
    if (!this.props.parentCom) {
      return;
    }

    const parent = this.props.parentCom;
    const portraitListElement = this.portraitListRef.current;
    if (!portraitListElement) return;
    const lastChild = portraitListElement.lastChild;
    if (!lastChild) return;
    const portraitWidth = lastChild.offsetWidth;
    const portraitListOffsetRight = lastChild.offsetLeft + portraitWidth;
    const sharedUserListOffsetWidth = this.SharedUserListRef.current.offsetWidth;
    const rightArrowWidth = this.rightArrowRef.current ? this.rightArrowRef.current.offsetWidth : 0;
    const removeOverflowPortrait = (gap) => {
      if (gap > 0) {
        const portraitMarginRight = parseInt(getComputedStyle(portraitListElement.lastChild).marginRight);
        const count = Math.ceil(gap / (portraitWidth + portraitMarginRight));
        const portraitListElementChildrenLens = portraitListElement.children.length;

        for (let i = portraitListElementChildrenLens - 1; i >= portraitListElementChildrenLens - count; i--) {
          portraitListElement.children[i].style.display = 'none';
          // !!lastChild && portraitListElement.removeChild(lastChild);
        }
      }
    };

    if (parent === 'CollaborationHeader') {
      const sharedUserListOffsetLeft = this.SharedUserListRef.current.offsetLeft;
      const gap = portraitListOffsetRight - sharedUserListOffsetLeft - sharedUserListOffsetWidth + rightArrowWidth;

      removeOverflowPortrait(gap);
    } else if (parent === 'SharedTable' || parent === 'Thumbnail') {
      // const tdPaddingLeft = parseInt(getComputedStyle(this.SharedUserListRef.current.parentElement).paddingLeft)
      const gap = portraitListOffsetRight - (sharedUserListOffsetWidth - rightArrowWidth);

      removeOverflowPortrait(gap);
    }
  };
  getOption = () => {
    return this.state.addOption.map((item) => {
      return (
        <Option key={item.value} value={item.value}>
          {item.value}
        </Option>
      );
    });
  };
  onChangeEmail = (value) => {
    this.setState({ email: value });
  };
  onSelect = (data) => {
    this.props.form.validateFields((err /*, values*/) => {
      if (!err) {
        const selectData = [...this.state.selectData];
        if (selectData.indexOf(data) === -1) {
          selectData.push(data);
          this.setState({ selectData, email: '' });
        }
      }
    });

    const { resetFields } = this.props.form;
    resetFields();
  };
  onSearch = (searchText) => {
    let addOption = [];
    if (searchText) {
      addOption = this.state.userList.map((item) => {
        return { value: `${searchText}${item}` };
      });
      addOption.unshift({ value: `${searchText}` });
    }
    this.setState({ addOption });
  };
  deleceEmailItem = (email) => {
    let emailList = [...this.state.selectData];
    this.setState({ selectData: emailList.filter((item) => item !== email) });
  };
  getBgIndex = (userId, index) => {
    // const length = this.state.userBgColorList.length;
    // if (!userId) return length - 1;
    // const key = userId[userId.length - 1];
    // var s = 'a b c d e f g h i j k l m n o p q r s t u v w x y z 0 1 2 3 4 5 6 7 8 9';
    // var sArray = s.split(' ');
    // let keyIndex = 0;
    // sArray.forEach((item, index) => {
    //   if (key === item) keyIndex = index % length;
    // });
    // return keyIndex;
    return index % 5;
  };
  getUserDetailsList = () => {
    const { propsData } = this.state;
    let list = propsData.peopleList;
    const propsPeopleList = this.props.peopleList ? this.props.peopleList : list;
    if (propsPeopleList.length > 0) list = [...propsPeopleList];
    list.forEach((item, index) => {
      item.bg = this.state.userBgColorList[this.getBgIndex(item.cUserID, index)];
    });
    store.collaborationStore.setShareUserList(list);
    return list.slice(0, 5).map((item, index) => {
      return (
        <li key={index} style={{ zIndex: 5 - index }}>
          <Tooltip
            // zIndex={10}
            color="#303133"
            overlayClassName="share"
            placement="bottom"
            title={this.getUserCommentAuthority(item)}
            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
          >
            {!!item.avatar && <i className="user-avatar" style={{ background: `url(${item.avatar}) no-repeat 0 0 / 24px 24px` }} />}
            {!item.avatar && (item.isGuest === 1 || !item.cUserID) && <i className="guest-avatar user-avatar" />}
            {!item.avatar && item.isGuest !== 1 && item.cUserID && (
              <p className="defaultPortrait" style={{ background: item.bg }}>
                {item.name[0].toUpperCase()}
              </p>
            )}
          </Tooltip>
        </li>
      );
    });
  };
  getSelectList = () => {
    return this.state.selectData.map((item, index) => {
      return (
        <li key={index}>
          {item}
          <span
            onClick={() => {
              this.deleceEmailItem(item);
            }}>
            x
          </span>
        </li>
      );
    });
  };
  validateEmail = (rule, value, callback) => {
    const { propsData } = this.state;
    const { peopleList } = propsData;
    const isHas = peopleList.some((item) => {
      if (item.email == value) {
        return true;
      }
    });
    if (value) {
      if (isHas) {
        callback(intl.get('collaboration.sharedList.Error.emailExists'));
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
  getContent = () => {
    const {
      // isSuccess, successLength,
      propsData,
    } = this.state;

    return (
      <div
        className="sharedPopoverBox"
        onClick={(e) => {
          e.stopPropagation();
        }}>
        <div className="title">
          参与者：{propsData.peopleList.length}人
          {/* {isSuccess && (
            <span className="successMsg">
              {intl.get('collaboration.sharedList.SharedUserList.SuccessText')}{successLength}
            </span>
          )} */}
        </div>
        <ul className="userList">
          <Spin spinning={this.state.userListLoading}>{this.getUserList()}</Spin>
        </ul>
      </div>
    );
  };
  getUserCommentAuthority = (item) => {
    let res;
    if (item.isOwner === 1) {
      res = '（所有者）';
    } else if (item.prohibitComment === 0) {
      res = '（可评论）';
    } else if (item.prohibitComment === 1) {
      res = '（可查看）';
    } else {
      res = '';
    }

    return `${item.name}${res}`;
  };
  getUserList = () => {
    const { detailsUserList } = this.state;

    return detailsUserList.map((item, index) => {
      return (
        <Tooltip
          key={index}
          overlayClassName="share"
          autoAdjustOverflow={false}
        //   zIndex={10}
          color="#303133"
          placement="bottom"
          title={this.getUserCommentAuthority(item)}
          //   getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          <li>
            <div className="headPortrait">
              {!!item.avatar && <i className="user-avatar" style={{ background: `url(${item.avatar}) no-repeat 0 0 / 20px 20px` }} />}
              {!item.avatar && item.isGuest === 1 && (item.isGuest === 1 || !item.cUserID) && <i className="guest-avatar user-avatar" />}
              {!item.avatar && item.isGuest !== 1 && item.isGuest !== 1 && item.cUserID && (
                <span style={{ background: item.bg }}>{item.name && item.name[0].toUpperCase()}</span>
              )}
            </div>
            <div className="content">
              <p>{this.getUserCommentAuthority(item)}</p>
              {/* <span className={["identity", item.isOwner !== 1 ? 'identity-gray' : ''].join(' ')}>
             {item.identity}
             {item.status&&<span> . {item.status}</span>}
           </span> */}
            </div>
          </li>
        </Tooltip>
      );
    });
  };
  showAdd = () => {
    store.userStore.doSendGAEvent({ eventKey: INVITE_PEOPLE, label: 'review_mode_upper_right_area' });

    this.setState({ isAddUser: true });
  };

  visibleChange = (visible) => {
    if (visible) {
      let parent = this.props.parentCom;
      if (parent === 'CollaborationHeader') {
        store.userStore.doSendGAEvent({ eventKey: VIEW_PARTICIPANTS, label: 'review_mode_upper_right_area' });
      }
      if (parent === 'SharedTable' || parent === 'Thumbnail') {
        if (store.collaborationStore.shareReviewListParams.source == '1') {
          store.userStore.doSendGAEvent({ eventKey: VIEW_PARTICIPANTS_BY_OTHERS, label: 'getting_started' });
        } else {
          store.userStore.doSendGAEvent({ eventKey: VIEW_PARTICIPANTS_BY_YOU, label: 'getting_started' });
        }
      }
    }

    if (!visible) {
      this.setState({
        isAddUser: false,
        addOption: [],
        selectData: [],
      });
    } else {
      this.getShareReviewInviteParticipant();
    }
    this.setState({ visible });
  };
  getShareReviewInviteParticipant = () => {
    const reviewSessionID = this.props.reviewSessionID ? this.props.reviewSessionID : this.state.propsData.reviewSessionID;
    const { outerInviteParticipant } = this.state;
    if (typeof outerInviteParticipant === 'undefined') {
      store.collaborationStore.getShareReviewInviteParticipant(reviewSessionID).then(
        (res) => {
          const { ret, data } = res;
          if (ret === 0) {
            this.setUserList(data.list);
            this.setState({
              userListLoading: false,
            });
          }
        },
        (error) => {
          this.setState({
            userListLoading: false,
          });
          console.log(error);
        },
      );
    } else {
      let setUserList = this.setUserList;
      outerInviteParticipant(reviewSessionID, (res) => {
        if (res) {
          setUserList(res);
          this.setState({
            userListLoading: false,
          });
        }
      });
    }
  };
  setUserList = (list) => {
    let { userId, avatar, isDefaultAvatar } = store.userStore;
    let hasAvatar = false;
    let guestTxt = intl.get('collaboration.sharedList.guest');
    const { platform } = store.appStore;
    list = list.map((item, index) => {
      if (userId == item.cUserID) {
        store.userStore.updateUserName({ showName: item.userName });
        if (platform === 'PhantomOnline' && !!window.pdfui) {
          pdfui.setUserName(item.userName);
        }

        if (item.avatar) {
          hasAvatar = true;
          avatar = item.avatar;
          isDefaultAvatar = 0;
        }
      }
      const name = item.isGuest === 1 ? guestTxt : item.userName || 'unknown';
      const bg = this.state.userBgColorList[this.getBgIndex(item.cUserID, index)];
      let identity = '';
      if (item.isOwner === 1) {
        identity = intl.get('collaboration.sharedList.SharedUserList.userIdentity');
      } else {
        if (item.isJoin === 0 || item.isJoin === 2) {
          identity = intl.get('collaboration.sharedList.SharedUserList.userNoOpen');
        } else {
          if (item.commentTime) {
            let commentTime = moment(UTCTimeToLocale(item.commentTime.substring(0, item.commentTime.length - 4))).format('YYYY-MM-DD HH:mm:ss');
            identity = `${intl.get('collaboration.sharedList.SharedUserList.userCommented')} ${commentTime}`;
          } else {
            identity = intl.get('collaboration.sharedList.SharedUserList.userOpened');
          }
        }
      }
      if (hasAvatar === true) {
        store.userStore.updateUserAvatar({ avatar, isDefaultAvatar });
      }
      return {
        name,
        identity,
        bg,
        ...item,
      };
    });
    this.setState(
      {
        detailsUserList: list,
        propsData: {
          ...this.state.propsData,
          peopleList: list,
        },
      },
      () => {
        if (!this.state.notPhantomOnline) {
          this.calcPortraitList();
        }
        store.collaborationStore.setShareUserList(list);
      },
    );
  };
  getShareReview = () => {
    store.collaborationStore.phantomGetShareReview().then((res) => {
      const { ret, data } = res;
      if (ret === 0) {
        const { people, type, shareState, fileLink, cDocID, reviewSessionID } = store.collaborationStore.formetShareData(data[0]);
        this.setState({
          propsData: {
            peopleList: people,
            type,
            shareState,
            fileLink,
            cDocID,
            reviewSessionID,
          },
        });
        this.getShareReviewInviteParticipant();
      } else {
        const errorMsg = intl.get('UnKnownError');
        store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: errorMsg });
        console.log(res.message);
      }
    });
  };
  saveUserListRef = (ref) => {
    this.userListRef = ref;
  };
  render() {
    const { visible, notPhantomOnline, isolateComponent, propsData } = this.state;
    const { peopleList } = propsData;
    let peopleLength = peopleList.length;
    const propsPeopleList = this.props.peopleList ? this.props.peopleList : propsData.peopleList;

    if (propsPeopleList.length > 0) peopleLength = propsPeopleList.length;
    let isBlack = getQueryVariable('isBlack') == 1;
    let blackClassName = isBlack ? 'blackContainer' : '';

    return (
      <div ref={this.SharedUserListRef} className={`SharedUserList ${blackClassName}`}>
        {!isolateComponent && (
          <div ref={this.totalUserRef} className="total-user">
            {peopleLength > 99 ? '99+' : peopleLength} {intl.get('collaboration.sharedList.SharedUserList.People')}
          </div>
        )}
        {!isolateComponent && (
          <ul ref={this.portraitListRef} className={['portraitList', peopleLength >= 99 ? 'morePortraitList' : ''].join(' ')}>
            {this.getUserDetailsList()}
          </ul>
        )}
        {!isolateComponent && (
          <Popover
            open={true}
            arrowPointAtCenter
            autoAdjustOverflow={false}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            zIndex={1050}
            content={this.getContent()}
            visible={visible}
            trigger="click"
            placement="bottomRight"
            onVisibleChange={this.visibleChange}>
            <div ref={this.rightArrowRef} className="right-arrow-btn" />
          </Popover>
        )}
        {notPhantomOnline && isolateComponent && (
          <div ref={this.saveUserListRef} className="userListDialog">
            {this.getContent()}
          </div>
        )}
      </div>
    );
  }
}
const WrapSharedUserList = Form.create({ name: 'SharedUserList' })(SharedUserList);

export default WrapSharedUserList;
